var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", [
    _c(
      "ol",
      { staticClass: "breadcrumb" },
      _vm._l(_vm.crumbs, function(crumb, index) {
        return _c(
          "li",
          { key: index, staticClass: "breadcrumb-item align-itrm-center" },
          [
            _c(
              "router-link",
              {
                class: { disabled: _vm.isLast(index) },
                attrs: { to: crumb.route }
              },
              [_vm._v(_vm._s(crumb.text))]
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78316544", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78316544","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blogs/components/Breadcrumb.vue
// module id = 2461
// module chunks = 0